import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar as CalendarPicker } from "@/components/ui/calendar";
import { CalendarDays } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");
const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const fromISO = (s) => (s ? new Date(s + "T00:00:00") : undefined);
const fmtDob = (s) => {
  if (!s) return "Select Date of Birth";
  const d = fromISO(s);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

/**
 * Shadcn Calendar + Popover wrapper used for picking a client's Date of
 * Birth on the Admin Client Profile. Stays a leaf component — no API
 * calls, no global state — so the surrounding form keeps total control
 * over the ISO date string lifecycle.
 */
export function DobPopover({ value, onChange, testId = "client-dob" }) {
  const selected = fromISO(value);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="w-full mt-1 justify-start text-left font-normal h-10"
          data-testid={testId}
          aria-label="Date of Birth"
        >
          <CalendarDays className="w-4 h-4 mr-2 text-muted-foreground" />
          {fmtDob(value)}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0">
        <CalendarPicker
          mode="single"
          selected={selected}
          onSelect={(d) => d && onChange(toISO(d))}
          captionLayout="dropdown"
          fromYear={1920}
          toYear={new Date().getFullYear()}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
